import React, { useState, useEffect } from 'react';

// Material UI
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

// Material UI Icons
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import SaveIcon from '@mui/icons-material/Save';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';


// Componentes 


// Funciones para obtener datos
import ObtenerRubro from '../functions/ObtenerRubro';
import InsertarRubro from '../functions/InsertarRubro';
import GuardarRubro from '../functions/GuardarRubro';

// Tipos de datos
import RubrosTabla from '../types/RubrosTabla';

// Indicador de procesamiento
import CircularProgress from '@mui/material/CircularProgress';

interface EditarRubroProps {
    idRubro: number;
    guardarCambios: (rubro: RubrosTabla) => void;
    cancelarCambios: () => void;
    eliminando: boolean;
}
  
export const EditarRubro: React.FC<EditarRubroProps> = ({ idRubro, guardarCambios, cancelarCambios, eliminando = false }) => {
  
    const [isLoading, setIsLoading] = useState(true);
    const [rubro, setRubro] = useState<RubrosTabla | null>(null);
    
    const [errorRubro, setErrorRubro] = useState<string | null>(null);

    const [localId, setLocalId] = useState(0);
    const [localRubro, setLocalRubro] = useState('');
    const [localHabilitado, setLocalHabilitado] = useState('');
    const [localFchCrea, setLocalFchCrea] = useState('');
    const [localFchModi, setLocalFchModi] = useState('');
    const [localDadoBaja, setLocalDadoBaja] = useState('');
    const [localFchBaja, setLocalFchBaja] = useState('');
    
    useEffect(() => {
        
        const fetchRubro = async () => {
            try {

                const data = await ObtenerRubro(idRubro);

                if (data.rubro_ok === 'si') {

                    // Todo ok, prestador recuperado

                    const RubroRecuperado: RubrosTabla = {
                        id: data.rubro[0].id,
                        rubro: data.rubro[0].rubro,
                        habilitado: data.rubro[0].habilitado,
                        fecha_creacion: data.rubro[0].fecha_creacion,
                        fecha_modificacion: data.rubro[0].fecha_modificacion,
                        dado_de_baja: data.rubro[0].dado_de_baja,
                        fecha_baja: data.rubro[0].fecha_baja
                    };

                    setRubro(RubroRecuperado);

                    setLocalId(data.rubro[0].id);
                    setLocalRubro(data.rubro[0].rubro);
                    setLocalHabilitado(data.rubro[0].habilitado);
                    setLocalFchCrea(data.rubro[0].fecha_creacion);
                    setLocalFchModi(data.rubro[0].fecha_modificacion);
                    setLocalDadoBaja(data.rubro[0].dado_de_baja);
                    setLocalFchBaja(data.rubro[0].fecha_baja);

                    setErrorRubro(null);
                } else {
                    
                    // Hubo errores al recuperar la pregunta frecuente
                    setErrorRubro(data.mensaje);
                    setLocalId(0);
                    setRubro(null);
                    setLocalRubro('');
                    setLocalHabilitado('');
                    setLocalFchCrea('');
                    setLocalFchModi('');
                    setLocalDadoBaja('');
                    setLocalFchBaja('');
                }

                setIsLoading(false);
                                
            } catch (err) {
                setErrorRubro('Error al obtener la información del rubro.');
                setLocalId(0);
                setRubro(null);
                setLocalHabilitado('');
                setLocalFchCrea('');
                setLocalFchModi('');
                setLocalDadoBaja('');
                setLocalFchBaja('');

                setIsLoading(false);
            }
        };

        if (idRubro > 0) {
            // Estoy editando un rubro existente
            fetchRubro();
        } else {
            // Estoy creando un nuevo rubro
            setIsLoading(false);
            setRubro({id:0, rubro:'', habilitado:'', fecha_creacion:'', fecha_modificacion:'', dado_de_baja:'', fecha_baja:''});
            setLocalId(0);
            setLocalRubro('');
            setLocalFchCrea('');
            setLocalFchModi('');
            setLocalFchBaja('');
            setLocalHabilitado('S');
            setLocalDadoBaja('N');
        }

    }, []);

    const handleChangeLocalRubro = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLocalRubro(event.target.value.toUpperCase());
    };


    const handleChangeLocalHabitado = (event: SelectChangeEvent) => {
        let valor = event.target.value;
        let valorMayuscula = valor.toUpperCase();
        setLocalHabilitado(valorMayuscula);
    };

    const handleChangeLocalDadoBaja = (event: SelectChangeEvent) => {
        let valor = event.target.value;
        let valorMayuscula = valor.toUpperCase();
        setLocalDadoBaja(valorMayuscula);
    };

    
    const guardarCambiosLocal = async () => {

        if (idRubro === 0) {
            // Crear nuevo rubro

            const RubroNuevo: RubrosTabla = {
                id: 0,
                rubro: localRubro,
                habilitado: localHabilitado,
                fecha_creacion: '',
                fecha_modificacion: '',
                dado_de_baja: 'N',
                fecha_baja: ''
            };
            
            try {
                const rubroInsertado = await InsertarRubro(RubroNuevo);

                if (rubroInsertado.rubro_insertado === 'si') {
                    guardarCambios(RubroNuevo);
                } else {
                    alert('Error al guardar los cambios: ' + rubroInsertado.mensaje);
                }
            } catch (error) {
                alert('Error al guardar los cambios: ' + error);
            }
        } else {

            if (eliminando) {
                
                // Se realiza la baja lógica del rubro
                // HABILITADO = N
                // DADO_BAJA = S
                const fechaActual = new Date().toISOString();
                const guardarFecha = fechaActual.slice(0, 10)+" "+fechaActual.slice(11, 19);

                // Modificar datos rubro
                const RubroEditado: RubrosTabla = {
                    id: idRubro,
                    rubro: localRubro,
                    habilitado: 'N',
                    fecha_creacion: localFchCrea,
                    fecha_modificacion: guardarFecha,
                    dado_de_baja: 'S',
                    fecha_baja: guardarFecha
                };

                const respuesta = await GuardarRubro(RubroEditado);

                if (respuesta.rubro_guardado === 'si') {
                    guardarCambios(RubroEditado);
                } else {
                    alert('Error al guardar los cambios: ' + respuesta.mensaje);
                }
                
            } else {
                
                // Modificar rubro
                const fechaActual = new Date().toISOString();
                const guardarFecha = fechaActual.slice(0, 10)+" "+fechaActual.slice(11, 19);
                
                // Modificar datos rubro
                const RubroEditado: RubrosTabla = {
                    id: idRubro,
                    rubro: localRubro,
                    habilitado: localHabilitado,
                    fecha_creacion: localFchCrea,
                    fecha_modificacion: guardarFecha,
                    dado_de_baja: localDadoBaja,
                    fecha_baja: localDadoBaja === 'S' ? guardarFecha : ''
                };

                const respuesta = await GuardarRubro(RubroEditado);

                if (respuesta.rubro_guardado === 'si') {
                    guardarCambios(RubroEditado);
                } else {
                    alert('Error al guardar los cambios: ' + respuesta.mensaje);
                }
            }
        }
    };
    return (
        <>
            {isLoading && (
                <div>
                    <p className="text-lg">Por favor espere</p>
                    <CircularProgress />
                </div>
            )}
            {(!isLoading && rubro) && (
                <div className="container mx-auto px-4 sm:px-6 lg:px-8 mt-5">
                    {eliminando ? (
                        <h1 className="font-metropolis text-xl text-red-700 font-bold mb-2">Eliminando Rubro: {rubro?.rubro}</h1>
                    ) : (
                        <h1 className="font-metropolis text-xl font-bold mb-2">{idRubro > 0 ? "Editando Rubro: " + rubro?.rubro : "Nuevo Rubro"}</h1>
                    )}
                    {/* Campos principales */}     
                    <div className="border-t-2 border-vp-azul w-full flex flex-row pt-3 justify-between items-start lg:space-x-2 xxs:flex-wrap xs:flex-wrap sm:flex-wrap md:flex-wrap lg:flex-wrap xl:flex-nowrap xxl:flex-nowrap mb-2">
                        <div className="flex flex-col justify-start items-center max-w-[120px] flex-grow w-full">
                            <TextField id="id" label="Id" variant="outlined" value={localId}
                                sx={{
                                    '& .MuiOutlinedInput-input': {
                                        padding: '8px',
                                    },
                                    '& .MuiInputLabel-outlined': {
                                        top: '-6px',
                                    },
                                    '& .MuiInputLabel-shrink': {
                                        top: '0px',
                                    },
                                    width: '100%',
                                    marginRight: '6px',
                                    marginBottom: '8px',
                                }}
                                disabled
                            />
                        </div>
                        <div className="flex flex-col justify-start items-center max-w-[380px] flex-grow w-full">
                            <TextField id="rubro" label="Rubro" variant="outlined" value={localRubro}
                                sx={{
                                    '& .MuiOutlinedInput-input': {
                                        padding: '8px',
                                    },
                                    '& .MuiInputLabel-outlined': {
                                        top: '-6px',
                                    },
                                    '& .MuiInputLabel-shrink': {
                                        top: '0px',
                                    },
                                    width: '100%',
                                    marginRight: '6px',
                                    marginBottom: '8px',
                                }}
                                onChange={handleChangeLocalRubro}
                                disabled={eliminando}
                            />
                        </div>
                        {/* Fechas y habilitado */}
                        {rubro.id > 0 && (<>
                            <div className="flex flex-col justify-between items-center max-w-[170px] flex-grow w-full">
                                <TextField id="fchcrea" label="Fec. Creado" variant="outlined" value={localFchCrea}
                                    sx={{
                                        '& .MuiOutlinedInput-input': {
                                            padding: '8px',
                                        },
                                        '& .MuiInputLabel-outlined': {
                                            top: '-6px',
                                        },
                                        '& .MuiInputLabel-shrink': {
                                            top: '0px',
                                        },
                                        width: '100%',
                                        marginRight: '6px',
                                        marginBottom: '8px',
                                    }}
                                    disabled
                                />
                            </div>
                            <div className="flex flex-col justify-between items-center max-w-[170px] flex-grow w-full">
                                <TextField id="fchcmodi" label="Fec. Modificado" variant="outlined" value={localFchModi}
                                    sx={{
                                        '& .MuiOutlinedInput-input': {
                                            padding: '8px',
                                        },
                                        '& .MuiInputLabel-outlined': {
                                            top: '-6px',
                                        },
                                        '& .MuiInputLabel-shrink': {
                                            top: '0px',
                                        },
                                        width: '100%',
                                        marginRight: '6px',
                                        marginBottom: '8px',
                                    }}
                                    disabled
                                />
                            </div>                                    
                        </>)
                        }
                        <div className="flex flex-col justify-between items-center max-w-[100px] flex-grow w-full">
                            <FormControl fullWidth sx={{marginRight: '6px',}}>
                                <InputLabel id="label-habilitado"
                                    sx={{top: '-6px',
                                        '&.MuiInputLabel-shrink': {
                                            transform: 'translate(14px, 0px) scale(0.75)',
                                        },
                                    }}
                                    >
                                        Habilitado
                                    </InputLabel>
                                <Select
                                    labelId="label-habilitado"
                                    id="habilitado"
                                    value={localHabilitado}
                                    label="Habilitado"
                                    sx={{
                                        '& .MuiOutlinedInput-input': {
                                            padding: '8px',
                                        },
                                        width: '100%',
                                        marginRight: '6px',
                                        marginBottom: '8px',
                                    }}
                                    onChange={handleChangeLocalHabitado}
                                    disabled={eliminando}
                                    >
                                    <MenuItem value={'S'}>Si</MenuItem>
                                    <MenuItem value={'N'}>No</MenuItem>
                                </Select>
                            </FormControl> 
                        </div>
                        <div className="flex flex-col justify-between items-center max-w-[100px] flex-grow w-full">
                            <FormControl fullWidth sx={{marginRight: '6px',}}>
                                <InputLabel id="label-dadobaja"
                                    sx={{top: '-6px',
                                        '&.MuiInputLabel-shrink': {
                                            transform: 'translate(14px, 0px) scale(0.75)',
                                        },
                                    }}
                                    >
                                        Baja
                                    </InputLabel>
                                <Select
                                    labelId="label-dadobaja"
                                    id="dadobaja"
                                    value={localDadoBaja}
                                    label="Baja"
                                    sx={{
                                        '& .MuiOutlinedInput-input': {
                                            padding: '8px',
                                        },
                                        width: '100%',
                                        marginRight: '6px',
                                        marginBottom: '8px',
                                    }}
                                    onChange={handleChangeLocalDadoBaja}
                                    disabled={eliminando}
                                    >
                                    <MenuItem value={'S'}>Si</MenuItem>
                                    <MenuItem value={'N'}>No</MenuItem>
                                </Select>
                            </FormControl> 
                        </div>
                        {localDadoBaja === 'S' && (
                            <div className="flex flex-col justify-between items-center max-w-[170px] flex-grow w-full">
                                <TextField id="fchbaja" label="Fec. Baja" variant="outlined" value={localFchBaja}
                                    sx={{
                                        '& .MuiOutlinedInput-input': {
                                            padding: '8px',
                                        },
                                        '& .MuiInputLabel-outlined': {
                                            top: '-6px',
                                        },
                                        '& .MuiInputLabel-shrink': {
                                            top: '0px',
                                        },
                                        width: '100%',
                                        marginRight: '6px',
                                        marginBottom: '8px',
                                    }}
                                    disabled
                                />
                            </div>)
                        }
                    </div>
                    <div className="flex flex-row justify-end items-center space-x-2">
                        {eliminando ? (
                            <>
                                <button className="mt-3 vp-btn-rojo-sm" onClick={guardarCambiosLocal} ><DeleteForeverIcon /> Eliminar</button>
                                <button className="mt-3 vp-btn-azul-sm" onClick={cancelarCambios} ><SettingsBackupRestoreIcon /> Cancelar</button>
                            </>
                        ) : (
                            <>
                                <button className="mt-3 vp-btn-azul-sm" onClick={guardarCambiosLocal} ><SaveIcon /> Guardar Cambios</button>
                                <button className="mt-3 vp-btn-rojo-sm" onClick={cancelarCambios} ><SettingsBackupRestoreIcon /> Cancelar</button>
                            </>
                        )}
                        
                    </div>
                </div>
            )}
        </>
    );
};
